import { PlayType } from '../../common/constants';
import { CacheDuration, MediaType } from '../../config/ProxyConfig';

export default function getCacheDuration(
  playType: PlayType,
  mediaType: MediaType,
  cacheDurations: CacheDuration[]
): number | undefined {
  const duration = cacheDurations.find(duration => {
    return mediaType == duration.mediaType && duration.playType === playType;
  });
  return duration ? duration.duration : undefined;
}
